<!-- 通知 -->
<template>
  <a-modal
    title="通知"
    width="800px"
    :visible="visible"
    @cancel="onClose"
    v-if="visible"
  >
    <div>
      <p>国家药品追溯监管系统触发式追溯监管模块于7月29日上线新功能：</p>
      <br/>
      <p>一是支持将用户权限开设到市县级，各省级系统管理员可以到登录过智慧监管平台-国家药品追溯监管系统，进入管理后台界面，对用户权限进行划分。</p>
      <br/>
      <p>二是新增选择“办理结果类型”选项，对于各省已办结的线索，请相关办理人员在系统中点击“修改办结”选项，补充办结结果类型。</p>
    </div>
    <template slot="footer">
      <a-button @click="onClose">确认</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  data() {
    return {
      visible: false,
      ruleForm: {},
      fileList: [],
    };
  },
  methods: {
    onClose() {
      this.$emit("handleFlag", false, this.modalData);
    },
  },
  watch: {
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
      }
    },
  },
};
</script>

<style scoped>
.list-item {
  padding: 6px;
  /* border-bottom: 1px solid #eee; */
  cursor: pointer;
  /* height: 30px; */
}
</style>
